import type { TimePeriod } from '@/lib/submissionFilter'

interface TimePeriodOption {
  id: TimePeriod
  label: string
}

const OPTIONS: readonly TimePeriodOption[] = [
  { id: 'all', label: 'All' },
  { id: 'today', label: 'Today' },
  { id: '7d', label: '7 days' },
  { id: 'custom', label: 'Custom range' },
]

interface TimePeriodChipsProps {
  value: TimePeriod
  onChange: (value: TimePeriod) => void
}

/**
 * Segmented control for the time-period filter. The selected chip uses the neon
 * accent on navy; the rest sit on navy-light, matching the recorder's controls.
 */
export function TimePeriodChips({ value, onChange }: TimePeriodChipsProps): JSX.Element {
  return (
    <div className="flex gap-2" role="group" aria-label="Filter by time period">
      {OPTIONS.map((option) => {
        const selected = option.id === value
        return (
          <button
            key={option.id}
            type="button"
            onClick={() => onChange(option.id)}
            aria-pressed={selected}
            className={`flex-1 whitespace-nowrap rounded-full px-3 py-2 text-xs font-semibold transition-all focus:outline-none focus:ring-2 focus:ring-neon-cyan/60 ${
              selected
                ? 'bg-neon-cyan text-navy shadow-sm'
                : 'bg-navy-light text-[#7cb0e8] hover:bg-navy-light/80 hover:text-[#a9cef5]'
            }`}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}
